

/// <reference path="StockCoreAnnotation.ts" />

// Generated class StockConsumptionAnnotation_ManagedObject

class StockConsumptionAnnotation_ManagedObject extends StockCoreAnnotation
{

    // Property: cashDeskID
    set cashDeskID(value:string) {
        this.setValueForKey(value, 'cashDeskID');
    }
    get cashDeskID():string {
        return this.valueForKey('cashDeskID');
    }
    set cashDeskIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'cashDeskID');
    }
    get cashDeskIDPrimitiveValue():string {
        return this.primitiveValueForKey('cashDeskID');
    }

    // Property: cashDeskName
    set cashDeskName(value:string) {
        this.setValueForKey(value, 'cashDeskName');
    }
    get cashDeskName():string {
        return this.valueForKey('cashDeskName');
    }
    set cashDeskNamePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'cashDeskName');
    }
    get cashDeskNamePrimitiveValue():string {
        return this.primitiveValueForKey('cashDeskName');
    }

    // Property: categoryID
    set categoryID(value:string) {
        this.setValueForKey(value, 'categoryID');
    }
    get categoryID():string {
        return this.valueForKey('categoryID');
    }
    set categoryIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'categoryID');
    }
    get categoryIDPrimitiveValue():string {
        return this.primitiveValueForKey('categoryID');
    }

    // Property: categoryName
    set categoryName(value:string) {
        this.setValueForKey(value, 'categoryName');
    }
    get categoryName():string {
        return this.valueForKey('categoryName');
    }
    set categoryNamePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'categoryName');
    }
    get categoryNamePrimitiveValue():string {
        return this.primitiveValueForKey('categoryName');
    }

    // Property: categoryTags
    set categoryTags(value:string) {
        this.setValueForKey(value, 'categoryTags');
    }
    get categoryTags():string {
        return this.valueForKey('categoryTags');
    }
    set categoryTagsPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'categoryTags');
    }
    get categoryTagsPrimitiveValue():string {
        return this.primitiveValueForKey('categoryTags');
    }

    // Property: computedCost
    set computedCost(value:number) {
        this.setValueForKey(value, 'computedCost');
    }
    get computedCost():number {
        return this.valueForKey('computedCost');
    }
    set computedCostPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'computedCost');
    }
    get computedCostPrimitiveValue():number {
        return this.primitiveValueForKey('computedCost');
    }

    // Property: computedTotalLineCost
    set computedTotalLineCost(value:number) {
        this.setValueForKey(value, 'computedTotalLineCost');
    }
    get computedTotalLineCost():number {
        return this.valueForKey('computedTotalLineCost');
    }
    set computedTotalLineCostPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'computedTotalLineCost');
    }
    get computedTotalLineCostPrimitiveValue():number {
        return this.primitiveValueForKey('computedTotalLineCost');
    }

    // Property: destinationName
    set destinationName(value:string) {
        this.setValueForKey(value, 'destinationName');
    }
    get destinationName():string {
        return this.valueForKey('destinationName');
    }
    set destinationNamePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'destinationName');
    }
    get destinationNamePrimitiveValue():string {
        return this.primitiveValueForKey('destinationName');
    }

    // Property: factor
    set factor(value:number) {
        this.setValueForKey(value, 'factor');
    }
    get factor():number {
        return this.valueForKey('factor');
    }
    set factorPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'factor');
    }
    get factorPrimitiveValue():number {
        return this.primitiveValueForKey('factor');
    }

    // Property: formatID
    set formatID(value:string) {
        this.setValueForKey(value, 'formatID');
    }
    get formatID():string {
        return this.valueForKey('formatID');
    }
    set formatIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'formatID');
    }
    get formatIDPrimitiveValue():string {
        return this.primitiveValueForKey('formatID');
    }

    // Property: locationCategoryID
    set locationCategoryID(value:string) {
        this.setValueForKey(value, 'locationCategoryID');
    }
    get locationCategoryID():string {
        return this.valueForKey('locationCategoryID');
    }
    set locationCategoryIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'locationCategoryID');
    }
    get locationCategoryIDPrimitiveValue():string {
        return this.primitiveValueForKey('locationCategoryID');
    }

    // Property: locationCategoryName
    set locationCategoryName(value:string) {
        this.setValueForKey(value, 'locationCategoryName');
    }
    get locationCategoryName():string {
        return this.valueForKey('locationCategoryName');
    }
    set locationCategoryNamePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'locationCategoryName');
    }
    get locationCategoryNamePrimitiveValue():string {
        return this.primitiveValueForKey('locationCategoryName');
    }

    // Property: locationID
    set locationID(value:string) {
        this.setValueForKey(value, 'locationID');
    }
    get locationID():string {
        return this.valueForKey('locationID');
    }
    set locationIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'locationID');
    }
    get locationIDPrimitiveValue():string {
        return this.primitiveValueForKey('locationID');
    }

    // Property: locationName
    set locationName(value:string) {
        this.setValueForKey(value, 'locationName');
    }
    get locationName():string {
        return this.valueForKey('locationName');
    }
    set locationNamePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'locationName');
    }
    get locationNamePrimitiveValue():string {
        return this.primitiveValueForKey('locationName');
    }

    // Property: minConsumptionQuantity
    set minConsumptionQuantity(value:number) {
        this.setValueForKey(value, 'minConsumptionQuantity');
    }
    get minConsumptionQuantity():number {
        return this.valueForKey('minConsumptionQuantity');
    }
    set minConsumptionQuantityPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'minConsumptionQuantity');
    }
    get minConsumptionQuantityPrimitiveValue():number {
        return this.primitiveValueForKey('minConsumptionQuantity');
    }

    // Property: minLossQuantity
    set minLossQuantity(value:number) {
        this.setValueForKey(value, 'minLossQuantity');
    }
    get minLossQuantity():number {
        return this.valueForKey('minLossQuantity');
    }
    set minLossQuantityPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'minLossQuantity');
    }
    get minLossQuantityPrimitiveValue():number {
        return this.primitiveValueForKey('minLossQuantity');
    }

    // Property: modifierID
    set modifierID(value:string) {
        this.setValueForKey(value, 'modifierID');
    }
    get modifierID():string {
        return this.valueForKey('modifierID');
    }
    set modifierIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'modifierID');
    }
    get modifierIDPrimitiveValue():string {
        return this.primitiveValueForKey('modifierID');
    }

    // Property: originName
    set originName(value:string) {
        this.setValueForKey(value, 'originName');
    }
    get originName():string {
        return this.valueForKey('originName');
    }
    set originNamePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'originName');
    }
    get originNamePrimitiveValue():string {
        return this.primitiveValueForKey('originName');
    }

    // Property: productElaborationType
    set productElaborationType(value:number) {
        this.setValueForKey(value, 'productElaborationType');
    }
    get productElaborationType():number {
        return this.valueForKey('productElaborationType');
    }
    set productElaborationTypePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'productElaborationType');
    }
    get productElaborationTypePrimitiveValue():number {
        return this.primitiveValueForKey('productElaborationType');
    }

    // Property: productTags
    set productTags(value:string) {
        this.setValueForKey(value, 'productTags');
    }
    get productTags():string {
        return this.valueForKey('productTags');
    }
    set productTagsPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'productTags');
    }
    get productTagsPrimitiveValue():string {
        return this.primitiveValueForKey('productTags');
    }

    // Property: sourceItemID
    set sourceItemID(value:string) {
        this.setValueForKey(value, 'sourceItemID');
    }
    get sourceItemID():string {
        return this.valueForKey('sourceItemID');
    }
    set sourceItemIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'sourceItemID');
    }
    get sourceItemIDPrimitiveValue():string {
        return this.primitiveValueForKey('sourceItemID');
    }

    // Property: subType
    set subType(value:number) {
        this.setValueForKey(value, 'subType');
    }
    get subType():number {
        return this.valueForKey('subType');
    }
    set subTypePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'subType');
    }
    get subTypePrimitiveValue():number {
        return this.primitiveValueForKey('subType');
    }

    // Property: totalConsumed
    set totalConsumed(value:number) {
        this.setValueForKey(value, 'totalConsumed');
    }
    get totalConsumed():number {
        return this.valueForKey('totalConsumed');
    }
    set totalConsumedPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'totalConsumed');
    }
    get totalConsumedPrimitiveValue():number {
        return this.primitiveValueForKey('totalConsumed');
    }

    // Property: type
    set type(value:number) {
        this.setValueForKey(value, 'type');
    }
    get type():number {
        return this.valueForKey('type');
    }
    set typePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'type');
    }
    get typePrimitiveValue():number {
        return this.primitiveValueForKey('type');
    }

    // Relationship: annotations
    protected _annotations:MIOManagedObjectSet = null;
    get annotations():MIOManagedObjectSet {
        return this.valueForKey('annotations');
    }
    addAnnotationsObject(value:AccountAnnotation) {
        this._addObjectForKey(value, 'annotations');
    }
    removeAnnotationsObject(value:AccountAnnotation) {
        this._removeObjectForKey(value, 'annotations');
    }

    // Relationship: children
    protected _children:MIOManagedObjectSet = null;
    get children():MIOManagedObjectSet {
        return this.valueForKey('children');
    }
    addChildrenObject(value:StockConsumptionAnnotation) {
        this._addObjectForKey(value, 'children');
    }
    removeChildrenObject(value:StockConsumptionAnnotation) {
        this._removeObjectForKey(value, 'children');
    }
    // Relationship: parent
    set parent(value:StockConsumptionAnnotation) {
        this.setValueForKey(value, 'parent');
    }
    get parent():StockConsumptionAnnotation {
        return this.valueForKey('parent') as StockConsumptionAnnotation;
    }
    // Relationship: salesAnnotation
    set salesAnnotation(value:SalesAnnotation) {
        this.setValueForKey(value, 'salesAnnotation');
    }
    get salesAnnotation():SalesAnnotation {
        return this.valueForKey('salesAnnotation') as SalesAnnotation;
    }
}
